import React from 'react'
import styles from './Text.module.css'

const h3=(props)=>{
	const textClasses=[styles.H3];
	if(props.lighter){
		textClasses.push(styles.H3Lighter)
	}
	return(
		<h4 className={textClasses.join(' ')}>{props.children}</h4>
	)
}

export default h3;
